import { Injectable } from '@angular/core';
import { BaseService} from './base.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Acesso } from '../models/acesso';

@Injectable({
  providedIn: 'root'
})
export class AcessoService extends BaseService {

  constructor(
    private http: HttpClient
  ) {super();}

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json; charset=UTF-8',
                                Authorization: 'my-auth-token',
                              }),
    params: {}
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
    }
    return throwError(errorMessage);
  };

  existeInscricaoCandidato(cpf : string) : Observable<any>{

    const url = this.UrlService+'acesso/CandidatoInscrito/?c='+cpf;
    return this.http.get<any>(url,this.httpOptions)
      .pipe(catchError(this.handleError));
  }

  validarInscricaoCandidato(acesso : Acesso){

    const url = this.UrlService+'acesso/ValidaCodInscricao/?n='+acesso.cpf+'&c='+acesso.inscricao;
    return this.http.get<any>(url,this.httpOptions)
      .pipe(catchError(this.handleError));
  }

}
